import Child from '../dto/Child';
import Error from '../model/Error';
import axios from 'axios';

export default class ChildRepository {

    static find(childId) {
        return new Promise((resolve, reject) => {
            axios
                .get('/children/' + childId)
                .then(response => resolve(Child.fromData(response.data.data)))
                .catch(error => reject(Error.fromResponse(error.response)));
        })
    }

    static findAllByKindergarten(kindergartenId) {
        return new Promise((resolve, reject) => {
            axios
                .get('/kindergartens/' + kindergartenId + '/children')
                .then(response => resolve(response.data.data.map(data => Child.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static uploadAvatar(childId, avatar, progressCallback) {
        const config = {
            onUploadProgress: function (progressEvent) {
                if (progressCallback) {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    progressCallback(percentCompleted);
                }
            },
            headers: {'Content-Type': 'application/octet-stream'}
        };

        return new Promise((resolve, reject) => {
            axios
                .put('/children/' + childId + '/avatar', avatar, config)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static removeAvatar(childId) {
        return new Promise((resolve, reject) => {
            axios
                .delete('/children/' + childId + '/avatar')
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static avatarUrl(childId, size, cacheBreaker) {
        let url = `/api/children/${childId}/avatar`;

        const params = new URLSearchParams();
        if (size) {
            params.append('size', size);
        }
        if (cacheBreaker) {
            params.append('cb', Date.now());
        }

        const queryString = params.toString();
        if (queryString) {
            url += `?${queryString}`;
        }

        return url;
    }

    static updateNotesGeneral(childId, notes) {
        return new Promise((resolve, reject) => {
            axios
                .put('/children/' + childId + '/notes-general', { notes })
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        })
    }

    static updateNotesAccounting(childId, notes) {
        return new Promise((resolve, reject) => {
            axios
                .put('/children/' + childId + '/notes-accounting', { notes })
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        })
    }
}
